export const CLAIMS_COLUMNS = [
    'ID',
    'FCN',
    'ESHOP_CLAIM_ID',
    'TRACKING_NUMBER',
    'SHIPPER',
    'ORDER_TYPE',
    'CREATED_AT',
    'RESOLVER',
    'STATUS',
    'ESHOP_ORDER_ID',
    'CLAIM_CAUSE',
    'CLAIM_CAUSE_OTHERS_TYPE',
    'ORDER_ID',
    'NOTE',
    'DESCRIPTION',
];

export const RETURNS_COLUMNS = [
    'RMA',
    'ESHOP_RETURN_ID',
    'ORDER_ID',
    'ESHOP_ORDER_ID',
    'RECIPIENT_NAME',
    'INVOICE_NUMBER',
    'CREATED_AT',
    'STATUS',
    'TRACKING_NUMBER',
    'SHIPPER',
    'SHIPPER_SERVICE_CODE',
    'ID',
    'ORDER_TYPE',
    'DESCRIPTION',
    'NOTE',
];
